import { getProgramScopedContentRows } from '../services/programScopedContentService';
import { getProgramWorkspaceScopeEntry } from './programEditWorkspace';
import { programAlignedImportColumnsHaveData } from './programLearningContentImport';
import { resolveTrackProgramLearningScopeKey } from './programLearningBatchGenerate';
import type { TrackProgramMode } from './trackProgramModeStorage';

function trackWorkspaceScopeId(params: {
  workspaceId: string;
  gradeId: string;
  academicYear: number;
  termNumber: 1 | 2;
  scopeKey: string;
}): string {
  return `track|${params.workspaceId}|${params.gradeId}|${params.academicYear}|${params.termNumber}|${params.scopeKey}`;
}

export function countFilledProgramLearningRows(
  rows: ReadonlyArray<Parameters<typeof programAlignedImportColumnsHaveData>[0][number]>
): number {
  return rows.filter((row) => programAlignedImportColumnsHaveData([row])).length;
}

export async function countTrackProgramLearningHours(params: {
  workspaceId: string;
  gradeId: string;
  academicYear: number;
  termNumber: 1 | 2;
  trackName: string;
  aliases: string[];
  programMode: TrackProgramMode;
  syncRepAlias: string;
}): Promise<number> {
  const scopeKey = resolveTrackProgramLearningScopeKey({
    trackName: params.trackName,
    aliases: params.aliases,
    programMode: params.programMode,
    syncRepAlias: params.syncRepAlias,
  });
  const dirty = getProgramWorkspaceScopeEntry(
    trackWorkspaceScopeId({
      workspaceId: params.workspaceId,
      gradeId: params.gradeId,
      academicYear: params.academicYear,
      termNumber: params.termNumber,
      scopeKey,
    })
  );
  if (dirty?.isDirty) {
    return countFilledProgramLearningRows(dirty.rows);
  }
  const rows = await getProgramScopedContentRows(
    params.workspaceId,
    params.academicYear,
    params.termNumber,
    params.gradeId,
    'track',
    scopeKey
  );
  return countFilledProgramLearningRows(rows);
}
